import { styled } from "styled-components";
import { radius } from "@libertify/ui";

export const SelectedItem = (element) => styled(element)`
  position: relative;
  border-radius: ${radius.box}px;
  border: 3px solid transparent;
  & {
    filter: ${({ theme }) => theme.filterDropShadow};
  }
  &.selected {
    border: ${({ theme }) => `3px solid ${theme.colorPrimary}`};
  }
  &.selected::after {
    content: "";
    position: absolute;
    border-radius: ${radius.circle};
    top: -8px;
    right: -8px;
    width: 31px;
    height: 31px;
    border: 3px solid white;
    background-color: ${({ theme }) => theme.colorPrimary};
    background-position: center;
    background-size: 18px;
    background-repeat: no-repeat;
    background-image: url("data:image/svg+xml;base64,Cjxzdmcgd2lkdGg9IjE0IiBoZWlnaHQ9IjEyIiB2aWV3Qm94PSIwIDAgMTQgMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMy4xNjQyIDAuODYyMTQ2QzEyLjk5NTQgMC44NjcxNDYgMTIuODM1IDAuOTM3MTQ2IDEyLjcxNzQgMS4wNTg5NUw0LjIxMTAzIDkuNTQ0MTVMMS4yOTA0MyA2LjYxNzE1QzEuMTY4NjMgNi40OTA5NSAxLjAwMDgzIDYuNDE4OTUgMC44MjQ4MjkgNi40MTg5NUMwLjI0MDQyOSA2LjQxNzE1IC0wLjA0OTE3MDcgNy4xMjc1NSAwLjM3MDYyOSA3LjUzNDc1TDMuNzQwNjMgMTAuOTEyOUMzLjc1MzIzIDEwLjkyNjUgMy43NjY2MyAxMC45MzkxIDMuNzgwMDMgMTAuOTUwNUM0LjA4MDAzIDExLjIzMjcgNC41NjQ0MyAxMS4xNjcxIDQuNzc5MDMgMTAuODE2MUwxMy42MzUyIDEuOTc5NTVDMTQuMDYzMiAxLjU2NzE1IDEzLjc1OCAwLjg0NDE0NiAxMy4xNjQyIDAuODYyMTQ2WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==");
  }
`;
